// Server maintenance — the admin-only instance operations. Sourced from
// specs/cli.md §5 (cairn server), specs/history.md (retention), and the
// Server page itself.

import { IconChartBar, IconDatabase, IconSettings } from "@tabler/icons-react";
import { CommandLine } from "@/components/command-line";
import { DocSection, K, P, Points } from "../doc-ui";

export function ServerMaintenanceDoc() {
  return (
    <>
      <P>
        Admins get the <K>Server</K> page (sidebar menu): instance stats, storage maintenance, and
        per-vault quotas. Every action there has a CLI twin under <K>cairn server</K>.
      </P>

      <DocSection icon={IconChartBar} title="Stats">
        <P>
          The dashboard shows what the instance is holding — vaults, users, storage. The same
          numbers in the terminal:
        </P>
        <CommandLine command="cairn server stats" />
      </DocSection>

      <DocSection
        icon={IconDatabase}
        title="Storage maintenance"
        description="Both are safe to run any time; they only reclaim space."
      >
        <Points>
          <li>
            <strong>Garbage collection</strong> — reclaims space from deleted content (deleted
            vaults, attachments past their grace window).
          </li>
          <li>
            <strong>Compaction</strong> — compacts document sync history to reduce storage. Can
            take a while on large instances. Version history survives compaction.
          </li>
        </Points>
        <CommandLine command="cairn server gc" />
        <CommandLine command="cairn server compaction" />
      </DocSection>

      <DocSection icon={IconSettings} title="Quotas">
        <P>Cap a vault's attachment storage (notes themselves are tiny; attachments are the cost):</P>
        <CommandLine command="cairn server quota <vault> <bytes>" />
      </DocSection>

      <DocSection
        icon={IconSettings}
        title="On the server host"
        description="A few things live in the server config file, not the API."
      >
        <Points>
          <li>
            <strong>Version-history retention</strong> — <K>[history] retention_days</K> (default
            365) and <K>attachment_gc_days</K> (default 30). Raising retention later can't bring
            back already-pruned versions, so the default is generous.
          </li>
          <li>
            <strong>Bootstrap &amp; recovery</strong> — the very first admin (or a
            locked-out-last-admin recovery) is minted on the host with the{" "}
            <K>cairn-server admin</K> tool, which talks to the database directly.
          </li>
        </Points>
      </DocSection>
    </>
  );
}
